import React from "react";
import styled from "styled-components";
import { bg_1_src } from "../images";

// Brand photograph panel. `bg-1.jpg` is a team/classroom photograph already
// used on the affiliators landing — reusing it keeps the brand voice
// consistent across the rebrand without requiring a new asset upload.
// `object-fit: cover` + `object-position: center` handles any aspect ratio
// without distorting faces.
const Wrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 100%;
  overflow: hidden;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
`;

// Subtle orange tint keeps the photo rhyming with the brand CTA on the form
// side without obscuring faces. Sits above the image, below any future
// overlay children we might add (e.g. a pull-quote).
const Tint = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(216, 89, 7, 0.08) 0%, rgba(247, 179, 12, 0.04) 100%);
  pointer-events: none;
`;

export default function AuthImagePanel() {
  return (
    <Wrap aria-hidden="true">
      <Img src={bg_1_src} alt="" />
      <Tint />
    </Wrap>
  );
}
